import { render, staticRenderFns } from "./AboutGfu.vue?vue&type=template&id=7c9cf689&scoped=true&"
import script from "./AboutGfu.vue?vue&type=script&lang=js&"
export * from "./AboutGfu.vue?vue&type=script&lang=js&"
import style0 from "./AboutGfu.vue?vue&type=style&index=0&id=7c9cf689&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9cf689",
  null
  
)

export default component.exports